import styled from 'styled-components';
import { Menu as MenuAntd, Divider as DividerAntd } from 'antd';
import color from '../../configs/color';
import thumbStyle from '../../configs/thumbStyle';

const MenuWrapper = styled.div`
  max-height: 100vh;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
`;

export default MenuWrapper;

export const Menu = styled(MenuAntd)`
  position: relative;
  height: 100%;
  width: 240px;
  padding: 0 16px;
  border-right: none;
  background-color: ${color.white};
  overflow-y: scroll;
  ${thumbStyle};

  .component_sidebar_last_item {
    margin-bottom: 100px !important;
  }

  .component_sideBar_logo_wrapper {
    text-align: center;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 5;
    background-color: ${color.white};
    padding-top: 24px;
    .component_sideBar_logo {
      height: 44px;
      margin-bottom: 24px;
    }
  }

  li.ant-menu-item-selected.active .anticon svg {
    color: ${color.green1};
  }

  li.ant-menu-item {
    min-height: 44px;
    color: ${color.black3};
    font-weight: 600;
    border-radius: 12px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: ${(props) => {
      return props.isCollapsed ? 'inherit' : '16px !important';
    }};
    &:not(:last-child) {
      margin-bottom: 8px;
    }
    .anticon svg {
      font-size: 16px;
      display: block;
    }

    a {
      color: inherit;
      vertical-align: sub;
    }
    ::after {
      border: none;
    }
    :hover {
      background: ${color.green6};
      color: ${color.black2};
      font-weight: 600;
      .anticon svg {
        color: ${color.green1};
      }
    }
  }
  .ant-menu-item-selected {
    background-color: white !important;
    color: ${color.black2} !important;
  }

  .ant-menu-item-selected.active {
    background-color: ${color.green6} !important;
    color: ${color.black2} !important;
  }

  li.ant-menu-item-active:hover {
    background-color: ${color.green6};
  }

  li#component_upgrade_account {
    border: 1px solid ${color.orange1};
    color: ${color.orange1} !important;
  }
  li.ant-menu-item-active#component_upgrade_account:hover {
    background-color: ${color.orange1};
    span,
    svg {
      color: white !important;
    }
  }
  li.ant-menu-item.component_sideBar_collapseItem {
    background-color: transparent;
    height: 44px;
    padding: 12px;
    padding-bottom: 16px;
    border: none;
    box-shadow: none;
    color: ${color.black3};
    font-size: 16px;
    font-weight: 600;
    .anticon svg {
      font-size: 16px;
      color: ${color.black3};
      margin-bottom: 4px;
    }
    :hover,
    :active {
      background-color: transparent;
      color: ${color.black3};
      font-weight: 600;
      .anticon svg {
        color: ${color.black3};
      }
    }
  }
  .ant-menu-item-selected.component_sideBar_collapseItem {
    background-color: ${color.white} !important;
    color: ${color.black3} !important;
  }
  li.ant-menu-item-selected.component_sideBar_collapseItem .anticon svg {
    color: ${color.black3};
  }

  .component_sideBar_collapsed {
    /* transition: 0.25s; */
    position: fixed;
    bottom: 0;
    background-color: ${color.white};

    &.opened {
      width: 202px;
    }
  }

  .component_sidebar_dummy-space {
    height: 14px;
  }

  .component_sideBar_padding {
    padding: 0 16px 16px 16px;
  }

  .component_sidebar_title {
    text-transform: capitalize;
    white-space: nowrap;
    margin-top: 24px;
    height: 20px;
    margin-bottom: 8px;
  }

  .component_sidebar_menu-unavailable {
    color: ${color.black3} !important;
  }

  .component_sidebar_menu-unavailable:hover {
    background-color: ${color.black6} !important;
    color: ${color.black3} !important;
    .anticon svg {
      color: ${color.black3} !important;
    }
  }
`;

export const Divider = styled(DividerAntd)`
  margin: 12px 0;
  border-color: ${color.grey1};
`;
